export const invertedMessages = {
  'The number of visible attributes depends on the size of your browser and screen. Any attributes not shown are visible in the detailed view.':
    'CERTS_COLUMN_FILTER_LABEL',
  Columns: 'CERTS_COLUMNS',
  User: 'User_DISPLAYNAME.CERTIFICATIONS',
  Account: 'Account_DISPLAYNAME.CERTIFICATIONS',
  Entitlement: 'Ent_DISPLAYNAME.CERTIFICATIONS',
  Role: 'Role_DISPLAYNAME.CERTIFICATIONS',
  'Child Entitlement': 'ChildEnt_DISPLAYNAME.CERTIFICATIONS',
};
